import { Array, Boolean, Null, Number, Optional, Record, Static, String, Union } from 'runtypes';

import { GroupedStatusRunType } from 'src/models/taskList/extras';

const OptionalActivityLinkDisplayValueRunType = Optional(Union(String, Number, Null));

export const ACTIVITY_LINK_ORIGIN_LINKS_DATA_TRANSFER_KEY = 'activityLinkOriginLinks';

export const ActivityLinkRunType = Record({
	aggregateId: OptionalActivityLinkDisplayValueRunType,
	contact: OptionalActivityLinkDisplayValueRunType,
	contactQTip: OptionalActivityLinkDisplayValueRunType,
	date: OptionalActivityLinkDisplayValueRunType,
	groupedStatus: Optional(GroupedStatusRunType.Or(Null)),
	information: OptionalActivityLinkDisplayValueRunType,
	informationQTip: OptionalActivityLinkDisplayValueRunType,
	moduleIconCSSClass: OptionalActivityLinkDisplayValueRunType,
	originEntryId: String.Or(Number),
	originModuleName: String,
	timestamp: OptionalActivityLinkDisplayValueRunType,
});

export type ActivityLink = Static<typeof ActivityLinkRunType>;

export type LinkedActivityRow = {
	contactLabel: string;
	contactTitle: string;
	dateLabel: string;
	icon: string;
	informationLabel: string;
	informationTitle: string;
	key: string;
	label: string;
	restricted: boolean;
} & ActivityLink;

export const ActivityLinkButtonRunType = Record({
	additionalQTip: String,
	aggregateId: String,
	aggregateVersion: Number,
	moduleIconCSSClass: String,
	originEntryId: Number,
	originLinks: Optional(Array(ActivityLinkRunType).Or(Null)),
	originModuleName: String,
	processId: String,
	render: Boolean,
});

export type ActivityLinkButton = Static<typeof ActivityLinkButtonRunType>;
